import type { IToastMessage } from '../interface';
import type { ToastStorage } from '../state/interface';

export default function isShowing(store: ToastStorage, message: Partial<IToastMessage>) {
    const results = message.id
        ? store.filter(item => (message.id && item.id ? message.id === item.id : true))
        : store.filter(item => item.text === message.text);

    return results.length > 0;
}
